import { Component, Input, OnChanges, SimpleChange, SimpleChanges } from '@angular/core';
import { AbstractControl, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'form-error',
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.css']
})

export class FormErrorComponent implements OnChanges {

  @Input()
  public control: AbstractControl;

  @Input()
  public formErrors = [];


  ngOnChanges(changes: SimpleChanges) {
    if (changes['formErrors']) {
      if (this.formErrors === undefined) {
        this.formErrors = [];
      }
    }
  }

  /**
   * Gibt zurück ob die Fehler im Formularelement angezeigt werden sollen
   *
   * @returns boolean
   */
  public showErrors = (): boolean => {
    if (this.control.disabled) {
      return false;
    }

    const errors = this.getErrors();
    return ((this.control.invalid && this.control.dirty) || errors.length > 0);
  }

  /**
   * Gibt die Fhlermeldungen des Formularfeldes zurück
   *
   * @returns string[]
   */
  public getErrors = (): string[] => {
    const controlName = this.getControlName();

    if (this.formErrors[controlName] !== undefined) {
      return this.formErrors[controlName];
    }

    return [];
  }

  /**
   * Gibt den Namen zu dem Kontrollelemennt zurück
   *
   * @returns string
   */
  private getControlName = (): string => {
    const parentControls = this.control.parent.controls;
    const controlName =  Object.keys(parentControls).find(
      name => this.control === parentControls[name]
    );

    return (controlName !== undefined) ? controlName : '';
  }

}
